module.exports = __webpack_public_path__ + "img/IMG-20200310-WA0041.7984ea00.jpg";